import { Epic } from 'redux-observable'
import { tag } from 'rxjs-spy/operators/tag'
import { filter, map, mergeMap, pluck } from 'rxjs/operators'
import { isOfType } from 'typesafe-actions'
import { EpicDependencies, RootState } from 'src/state/types'
import { ENDPOINTS } from './constants'
import { events, SmsEvent } from './state'

export const apiSendSms: Epic<SmsEvent, SmsEvent, RootState, EpicDependencies> = (
  action$,
  state$,
  { post, catchRestError },
) =>
  action$.pipe(
    filter(isOfType(events.sendSms_request.type)),
    mergeMap(action =>
      post(ENDPOINTS.SEND_SMS, state$, action.payload, {}).pipe(
        pluck('response'),
        map(events.sendSms_success),
        catchRestError(action),
      ),
    ),
    tag('sms/epics/apiSendSms'),
  )

export const apiGetOtp: Epic<SmsEvent, SmsEvent, RootState, EpicDependencies> = (
  action$,
  state$,
  { post, catchRestError },
) =>
  action$.pipe(
    filter(isOfType(events.getOtp_request.type)),
    mergeMap(action =>
      // the backend picks the channel (email when the user has an address on file,
      // SMS otherwise) and the delivery address from the user's own profile, so the
      // only thing worth sending is the invitee on the invite-user flow
      post(ENDPOINTS.GET_OTP, state$, { inviteeEmail: action.payload.inviteeEmail }, {}).pipe(
        pluck('response'),
        map(events.getOtp_success),
        catchRestError(action),
      ),
    ),
    tag('sms/epics/apiGetOtp'),
  )
